<!-- 
  --------------------------------------------------------------
  --------------------------------------------------------------
  --------------------------------------------------------------
  @time: 2025/02/19
  @author: 邻家大龙猫
  @description: "验证码" 组件封装
  --------------------------------------------------------------
  --------------------------------------------------------------
  --------------------------------------------------------------
 -->


<template>
  <div class="verification-code__container" v-if="visible">
    <div class="verification-code__box">
      <div class="verification-code__head">
        <!-- <h3 class="verification-code__title">Verify your email address</h3> -->
        <h3 class="verification-code__title">{{ varificationCode.title }}</h3>
        <div>
          <p v-html="varificationCode.desc1.replace('$email', dataInfo && dataInfo.email ? `（${dataInfo.email}）` : '').replace('$length', codeLength)"></p>
          <p style="display:flex;justify-content:center;align-items:center;">
            <span>{{ varificationCode.desc2 }}</span>
            <template>
              <el-button :loading="isSending" class="verification-code__btn" @click="onSentCode" v-if="isSending">
                <span>{{ varificationCode.btnTxt2 }}</span>
              </el-button>
              <button class="verification-code__btn" style="background-color:rgba(6, 51, 88, 0.6);" v-else-if="countDownTime >= 0">
                <span>{{ varificationCode.btnTxt1 }}</span>
                <span> ({{ countDownTime }})</span>
              </button>
              <button class="verification-code__btn" @click="onSentCode" v-else>
                <span>{{ varificationCode.btnTxt1 }}</span>
              </button>
            </template>
          </p>
        </div>
      </div>
      <div class="verification-code__body">
        <el-input
          v-model="emailCode"
          type="number"
          ref="codeInputRef"
          class="verification-code__inp"
          @blur="isFocus = false"
          @focus="isFocus = true"
          @input="handleCodeInput"
        ></el-input>
        <ul class="verification-code__list">
          <li class="verification-code__item" v-for="(n,i) in codeLength" :key="n" @click="handleCodeBoxClick">
            <span
              class="verification-code__cursor"
              v-if="isFocus && i == cursorIndex"
            ></span>
            <span v-else>{{ emailCode[i] }}</span>
          </li>
        </ul>
      </div>
      <div class="verification-code__foot">
        <div class="verification-code__foot-btn verification-code__foot-btn-close" @click="close">{{ varificationCode.closeBtn }}</div>
        <el-button
          type="text"
          :loading="isSubmiting"
          v-if="isSubmiting"
          class="verification-code__foot-btn verification-code__foot-btn-confirm"
        >
          <span>{{ varificationCode.confirmBtn }}</span>
        </el-button>
        <div
          v-else
          class="verification-code__foot-btn verification-code__foot-btn-confirm"
          @click="onSubmit"
        >{{ varificationCode.confirmBtn }}</div>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { sendEmail } from "@/utils/http.js"


export default {
  name: 'VerificationCode',

  emits: ['on-submit'],

  data() {
    return {
      visible: false,
      dataInfo: {},
      countDownTime: -1,
      countDownTimer: null,
      isSubmiting: false,
      isSending: false,
      isFocus: false,
      emailCode: '',
      codeLength: 4,
    }
  },

  computed: {
    ...mapGetters(["currentLang"]),
    varificationCode() {
      return this.currentLang.config.contactUs.varificationCode;
    },

    cursorIndex() {
      return this.emailCode.length
    }
  },

  created() {
    
  },

  methods: {
    open(info) {
      console.log('info', { ...info })
      this.dataInfo = info ? { ...info } : {}
      this.setFocus()
      if (this.countDownTime < 0) {
        this.onSentCode()
      }
      this.visible = true
    },

    close() {
      this.reset()
      this.visible = false
    },

    reset() {
      this.emailCode = ''
      this.$refs.codeInputRef && this.$refs.codeInputRef.blur()
      this.dataInfo = {}
    },

    // 提交按钮回调
    onSubmit() {
      if (this.emailCode.length < this.codeLength) {
        return
      }
      this.$emit('on-submit', {
        ...this.dataInfo,
        emailCode: this.emailCode
      })
    },

    // 验证码倒计时
    handleCountDown() {
      this.countDownTime -= 1
      if (this.countDownTime < 0) {
        clearTimeout(this.countDownTimer)
        this.countDownTimer = null
        return
      }
      this.countDownTimer = setTimeout(() => {
        this.handleCountDown()
      }, 1000)
    },

    // 设置输入框获取焦点
    setFocus() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.codeInputRef && this.$refs.codeInputRef.focus() 
        }, 100)
      })
    },

    // 
    handleCodeBoxClick() {
      this.setFocus()
    },

    // 验证码输入回调
    handleCodeInput(value) {
      const { codeLength } = this
      this.emailCode = value.length > codeLength ? value.slice(0, codeLength) : value
      console.log('this.emailCode', this.emailCode)
    },

    // 发送验证码
    onSentCode() {
      const email = this.dataInfo && this.dataInfo.email ? this.dataInfo.email : ''
      if (!email)
        return this.$message.warning(this.varificationCode.getErrorTip1)
      
      if (this.isSending) return
      this.isSending = true
      sendEmail({ email: email })
        .then(res => {
          if (res.code === 1) {
            this.$message.success(this.varificationCode.getSuccessTip)
            this.countDownTime = 60
            this.handleCountDown()
          }
        })
        .catch(err => {
          this.$message.error(this.varificationCode.getErrorTip2)
        })
        .finally(() => {
          this.isSending = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.verification-code__container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 150;
  background-color: rgba(0, 0, 0, 0.6);
  font-size: var(--text-size-normal);
}

.verification-code__box {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 200;
  transform: translate(-50%, -50%);
  width: 750px;
  padding: 40px 40px;
  background-color: #fff;
  border-radius: 15px;

  .verification-code__head {
    
    .verification-code__title {
      margin-bottom: 18px;
      text-align: center;
      font-size: 26px;
      font-weight: 500;
      letter-spacing: 2px;
    }

    p {
      margin-bottom: 15px;
      text-align: center;
      color: #333;
      font-size: var(--text-size-normal);
      font-size: var(--text-size-bit-larger);
    }

    .verification-code__btn {
      margin-left: 10px;
      padding: 8px 12px;
      border: 1px solid var(--main-color-blue);
      border-radius: 8px;
      background-color: var(--main-color-blue);
      color: #fff;
      cursor: pointer;
      font-size: 16px;
    }
  }


  .verification-code__body {
    margin: 40px 0 80px;
    
    .verification-code__list {
      display: flex;
      justify-content: center;
    }

    .verification-code__item {
      position: relative;
      width: 70px;
      height: 80px;
      margin-right: 10px;
      // border-radius: 8px;
      line-height: 80px;
      text-align: center;
      font-size: 50px;
      font-weight: 500;
      cursor: pointer;
    }

    .verification-code__item::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 35%;
      height: 2px;
      background-color: #000;
      border-radius: 5px;
    }

    .verification-code__item:last-child {
      margin-right: 0;
    }

    .verification-code__cursor {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -40%);
      width: 2px;
      height: 65%;
      border-radius: 2px;
      background: rgba(0, 0, 0, 1);
      animation-name: shows;
      animation-duration: 0.5s;
      animation-direction: alternate-reverse;
      animation-iteration-count: infinite;
      animation-timing-function: none;
    }

    .verification-code__inp {
      position: fixed;
      top: -10000px;
    }
  }


  .verification-code__foot {
    display: flex;
    justify-content: center;
    margin-top: 80px;

    .verification-code__foot-btn {
      padding: 6px 20px;
      border: 1px solid var(--main-color-blue);
      border-radius: 8px;
      color: #333;
      cursor: pointer;
      font-size: 16px;
    }

    .verification-code__foot-btn-confirm {
      margin-left: 20px;
      background-color: var(--main-color-blue);
      color: #fff;
    }
  }
}
</style>

<style>
@keyframes shows {
  0% {
    background: rgba(0, 0, 0, 1);
  }

  100% {
    background: rgba(0, 0, 0, 0);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/callMe/modules/verification_code.vue